import React from 'react';
import Unauthorized from './Unauthorized';
import Upgrade from './Upgrade';
import AcceptInvitation from './AcceptInvitation';

export const utilityRoutes = [
  {
    path: '/unauthorized',
    element: <Unauthorized />,
    protected: false,
  },
  {
    path: '/upgrade',
    element: <Upgrade />,
    protected: true,
  },
  {
    path: '/accept-invitation',
    element: <AcceptInvitation />,
    protected: false,
  },
];
